import { gql } from '@apollo/client';

const Fragments = {
  incomeSourceItem: gql`
    fragment incomeSourceItem on IncomeSourceItem {
      id
      orderNo
      code
      name
      description
      hasSummary
      fromExternalSource
      isExpense
      incomeSourceArea
      isActive
      partnerTypeId
    }
  `,
  incomeSourceDetailItem: gql`
    fragment incomeSourceDetailItem on IncomeSourceDetailItem {
      id
      incomeSourceId
      orderNo
      code
      name
      description
      dataTypeId
      isReadOnly
      periodTypeId
      isSummary
      isActive
      validationFormula
      formula
      validationMessage
    }
  `,
  incomeSourceDetailValueItem: gql`
    fragment incomeSourceDetailValueItem on IncomeSourceDetailValueItem {
      id
      detailId
      code
      name
    }
  `
};

export default Fragments;
